import { useEffect } from "react";
import { RECEIVE_TIME, Timer } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitTimerActions } from "./toolkitTimerStore";

export function useToolkitTimerRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== RECEIVE_TIME) {
        return;
      }

      toolkitTimerActions.setTime((action.payload ?? {}) as Timer);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
